import { isFirefox, numberOfRows, rowSize } from './Constants';

export function scrollToTop() {
    if (isFirefox) {
        window.scrollTo({ top: 0 });
    }
    else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
}

export function scrollToAnchor(anchor) {
    const anchorElement = document.querySelector(anchor);
    if (!anchorElement) return;
    if (isFirefox) anchorElement.scrollIntoView()
    else anchorElement.scrollIntoView({ behavior: 'smooth' })
}

// Sorts item groups depending on the option the user chose in the interface, as follows:
//     1 = Best Sellers
//     2 = Now Trending
//     3 = Price(Low - High)
//     4 = Price(High - Low)
//     5 = Top Rated
//     6 = Newest
//     7 = Default
export function getSortedItemGroups(itemGroups, sortID) {
    if (!itemGroups) return;

    switch (parseInt(sortID)) {
        case 1:
            //Not defined
            return itemGroups;
        case 2:
            //Not defined
            return itemGroups;
        case 3:
            return itemGroups.sort((a, b) => parseFloat(a.LowestPrice) - parseFloat(b.LowestPrice));
            break;
        case 4:
            return itemGroups.sort((a, b) => parseFloat(b.LowestPrice) - parseFloat(a.LowestPrice));
            break;
        case 5:
            //Not defined
            return itemGroups;
        case 6:
            return itemGroups.sort((a, b) => new Date(+(b.LastModified).replace(/\D/g, '')) - new Date(+(a.LastModified).replace(/\D/g, '')));
            break;
        case 7:
            return itemGroups.sort((a, b) => parseInt(a.SortOrder) - parseInt(b.SortOrder));
            break;
        default:
            return itemGroups;
    }
}

export function getRowSize() {
    if (!window.screen.width) return 4;
    if (window.screen.width >= 992) return 4;
    if (window.screen.width >= 768 && window.screen.width < 992) return 3;
    if (window.screen.width < 768) return 2;
}

export function toggleFilterPanel() {
    var isOpen = $('#mobileFilters').hasClass('slide-in-mobile');
    if (isOpen == false) {
        $('#greyerFilters').show();
        $('#mobileFilters').removeClass('slide-out-mobile');
        $('#mobileFilters').addClass('slide-in-mobile');
        $('#greyerFilters').removeClass('fade-out-mobile');
        $('#greyerFilters').addClass('fade-in-mobile');
    }
    else {
        $('#mobileFilters').removeClass('slide-in-mobile');
        $('#mobileFilters').addClass('slide-out-mobile');
        $('#greyerFilters').removeClass('fade-in-mobile');
        $('#greyerFilters').addClass('fade-out-mobile');
        setTimeout(function () {
            $('#greyerFilters').hide();
        }, 200);
    }
}

export function getBounds(page, model) {
    const lowerBound = (page - 1) * numberOfRows * rowSize;
    return [lowerBound, Math.min(lowerBound + (numberOfRows * rowSize), model.itemGroupModel.length)];
}

export function getProductSlug(url) {
    if (url) {
        url = url.replace(/[^a-zA-Z 0-9'.@]/g, ' ');  // Remove invalid chars
        url = url.replace(/\s+/g, ' ').trim();        // Trim whitespace
        url = url.replace(/\s/g, "-");                // Whitespace => hyphen
        url = url.replace(/^\-+|\-+$/g, '');          // Remove trailing hyphen
        url = url.replace(/-{2,}/g, '-');             // Remove double hyphens
        return url.toLowerCase();
    }
    return '';
}

export function twoDecimalPlaces(num) {
    return (Math.round(num * 100) / 100).toFixed(2);
}

export function plurOrSing(txt, qty) {
    return qty > 1 ? txt + "s" : txt;
}

export function listClick(menu, i = null) {
    const index = (i !== null ? "-" + i : "");
    $("#spinning-svg" + index).toggleClass('spin-arrow');
    menu.fadeToggle(270);
}

export function listBlur(menu, i = null) {
    const index = (i !== null ? "-" + i : "");
    if ($("#spinning-svg" + index).hasClass('spin-arrow')) {
        $("#spinning-svg" + index).toggleClass('spin-arrow');
        menu.fadeToggle(270);
    }
}

export function productLogInClick() {
    if (window.innerWidth >= 768) {
        scrollToTop();
        ToggleLoginPanel();
    }
    else ToggleMobilePanel(true);
}

export function revertQuantity(updateCart, itemIndex, uomIndex) {
    const uom = updateCart.ItemList[itemIndex].UoMPrices[uomIndex];
    updateCart.ItemList[itemIndex].UoMPrices[uomIndex].QtyOrdered -= uom.QtyDiff;
    $(`#quantity-${itemIndex}-${uomIndex}`).val($(`#quantity-${itemIndex}-${uomIndex}`).val() - uom.QtyDiff);
}

export function adjustLeft(e, mainWindow = false) {
    if (!mainWindow) {
        $('.group-hover').hide();
        $(e.currentTarget).find('.group-hover').show();
    }
    if (window.innerWidth < 768 || (window.innerWidth >= 992 && window.innerWidth < 1200 )) return;
    const toolTip = $(e.currentTarget).find('.customize-order-tooltip');
    const iconContainer = !!$(e.currentTarget).find('i').length ? $(e.currentTarget).find('i') : $(e.currentTarget).find('img');
    toolTip.css("left", (iconContainer.outerWidth() - toolTip.outerWidth()) / 2)
}